import HostedCheckout from "./HostedCheckout";

/**
 * Service subscription payment through CIB Hosted Checkout.
 * Used by the Service Subscription page
 * (src/components/Parent/ServiceSubscription.tsx).
 */

interface Props {
  /** Total shown to the parent; the server charges the sum of students' fees. */
  amount: number;
  /** Selected service row. */
  installment: any;
  /** Students to subscribe. */
  students: any[];
  onFinish: (result: any) => void;
  /** Ignored - kept so existing callers still type-check. */
  code?: string;
}

export default function PayService({ amount, installment, students, onFinish }: Props) {
  return (
    <HostedCheckout
      endpoint="payment/service/createsession.php"
      payload={{ ...installment, students, paidamount: amount }}
      onFinish={onFinish}
    />
  );
}
